import axios from 'axios'
import { buildFormData, multipartHeader } from '@/axios'
const API_PATH = 'timelines'

export default {
    namespaced: true,
    state: {
        filter: {
            group_id: '',
            topic: ''
        },
        data: [],
        loading: false,
        selected: {
            loading: false,
            data: {
                author: {}
            }
        }
    },
    mutations: {
        SET_DATA (state, val) {
            state.data = val
        },
        APPEND_DATA (state, val) {
            val.forEach(i => {
                if (state.data.findIndex(item => item.id === i.id) < 0) {
                    state.data.push(i)
                }
            })
        },
        PREPEND_DATA (state, val) {
            state.data = [...val, ...state.data]
        },
        SET_LOADING (state, val) {
            state.loading = val
        },
        SET_SELECTED_DATA (state, val) {
            state.selected.data = val
        },
        SET_SELECTED_LOADING (state, val) {
            state.selected.loading = val
        }
    },
    actions: {
        fetch ({ commit }, params) {
            commit('SET_LOADING', true)
            return new Promise((resolve, reject) => {
                axios.get(API_PATH, { params })
                    .then((res) => res.data)
                    .then((res) => {
                        if (params.append) {
                            if (params.page === 1) {
                                commit('SET_DATA', [])
                            }
                            commit('APPEND_DATA', res.result.data)
                        } else {
                            commit('SET_DATA', [])
                            commit('SET_DATA', res.result.data)
                        }
                        resolve(res.result)
                    })
                    .catch(reject)
                    .finally(() => commit('SET_LOADING', false))
            })
        },
        create ({ commit, dispatch }, data) {
            return new Promise((resolve, reject) => {
                axios.post(API_PATH, buildFormData(data), multipartHeader)
                    .then((res) => res.data)
                    .then((res) => res.result)
                    .then((data) => {
                        commit('PREPEND_DATA', [data])
                        resolve(data)
                    })
                    .catch(reject)
            })
        },
        update ({ commit, dispatch }, { id, data }) {
            return new Promise((resolve, reject) => {
                axios.put(`${API_PATH}/${id}`, data)
                .then((res) => res.data)
                .then((res) => res.result)
                .then(async (data) => {
                    await dispatch('fetch', { group_id: data.group ? data.group.slug : '' })
                    resolve(data)
                })
                .catch(reject)
            })
        },
        show ({ commit }, slug) {
            commit('SET_SELECTED_LOADING', true)
            return new Promise((resolve, reject) => {
                axios.get(`${API_PATH}/${slug}`)
                    .then((res) => res.data)
                    .then((res) => {
                        commit('SET_SELECTED_DATA', res.result)
                        resolve(res.result)
                    })
                    .catch(reject)
                    .finally(() => commit('SET_SELECTED_LOADING', false))
            })
        },
        addComment ({ commit }, { slug, content, parentId, attachments }) {
            return new Promise((resolve, reject) => {
                axios.post(`${API_PATH}/${slug}/comment`, buildFormData({ content, parent_id: parentId, attachments }), multipartHeader)
                    .then(res => res.data)
                    .then(res => res.result)
                    .then(resolve)
                    .catch(reject)
            })
        },
        enableComment ({ commit }, slug) {
            return axios.post(`${API_PATH}/${slug}/enable-comment`)
        },
        disableComment ({ commit }, slug) {
            return axios.post(`${API_PATH}/${slug}/disable-comment`)
        },
        delete ({ commit, dispatch }, slug) {
            return new Promise((resolve, reject) => {
                axios.delete(`${API_PATH}/${slug}`)
                    .then((res) => res.data)
                    .then((res) => res.result)
                    .then(async (data) => {
                        await dispatch('fetch', { group_id: data.group_slug })
                        resolve(data)
                    })
                    .catch(reject)
            })
        },
        like ({ commit }, id) {
            return axios.post(`${API_PATH}/${id}/like`)
        },
        unlike ({ commit }, id) {
            return axios.post(`${API_PATH}/${id}/unlike`)
        }
    }
}
